import React from 'react';
import styled, { css } from 'styled-components';

const CircleArrow = ({ width = 45, height = 45, ...props }) => (
  <StyledSvg
    width={width}
    height={height}
    viewBox="0 -2 46 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g>
      <circle
        cx="23"
        cy="23"
        r="22"
        transform="rotate(180 23 23)"
        fill="white"
        stroke="black"
        strokeWidth="1"
      />

      <path
        d="M30.6347 21.5771L18.7425 21.5771L24.2049 16.3248L22.8173 15L15 22.5167L22.8173 30.0333L24.1951 28.7085L18.7426 23.4562L30.6347 23.4562L30.6347 21.5771Z"
        fill="black"
      />
    </g>
  </StyledSvg>
);

export default CircleArrow;

const CommonFill = css`
  circle {
    fill: var(--darkest);
  }
  path {
    fill: var(--white);
  }
`;
const StyledSvg = styled.svg`
  cursor: pointer;
  &:active {
    ${CommonFill}
  }
  @media (hover: hover) {
    &:hover {
      ${CommonFill}
    }
  }
`;
